// WordPress dependencies
import { PanelBody, PanelHeader, PanelRow } from "@wordpress/components";
import { __ } from "@wordpress/i18n";

// Internal dependencies
import ProFeatureControl from "../elements/pro-feature-control";
import ColorControl from "../control/color-control";
import GradientControl from "../control/gradient-control";

const coreAssets = window.COCA_BAIS_ASSETS;

export default (props) => {
    const getAttr = (attribute) => {
        const store = props.attributes;
        return !!store[attribute] ? store[attribute] : "";
    };

    return (
        <PanelBody
            title={
                <div className="components-panel__body-title__content">
                    <span>{__("Overlay", "wp-before-after-image-slider")} </span>
                    {!!props.proFeatureEnabled ? null : (
                        <a
                            href="https://codecanel.com/wp-before-after-image-slider/#product-pricing"
                            target="_blank"
                            style={{ marginTop: "6px" }}
                            title="Buy Pro"
                            onClick={function (e) {
                                e.stopPropagation();
                            }}
                        >
                            <img src={coreAssets.icons.premium} alt="Premium Icon" />
                        </a>
                    )}
                </div>
            }
            initialOpen={false}
            opened={props.attributes.overlay_panel_open}
            onToggle={() =>
                props.updateAttributes({
                    overlay_panel_open: !props.attributes.overlay_panel_open,
                })
            }
        >
            <PanelRow>
                <ProFeatureControl {...props} value={"overlay_color_normal"}>
                    <div className={"field-control field-inline"}>
                        <span className="field-control__label">
                            {__("Background Color", "wp-before-after-image-slider")}
                        </span>
                        <div className={"fields-wrapper inline"}>
                            <div className={"field"}>
                                {ColorControl({
                                    props,
                                    attribute: "overlay_color_normal",
                                    defaultValue: "rgba(0, 0, 0, 0)",
                                    labelText: __("Default", "wp-before-after-image-slider"),
                                    resetText: __("Clear", "wp-before-after-image-slider"),
                                })}
                            </div>
                            <div className={"field"}>
                                {ColorControl({
                                    props,
                                    attribute: "overlay_color_hover",
                                    defaultValue: "rgba(0, 0, 0, 0.5)",
                                    labelText: __("Hover", "wp-before-after-image-slider"),
                                    resetText: __("Clear", "wp-before-after-image-slider"),
                                })}
                            </div>
                        </div>
                    </div>
                    <div className={"field-control field-inline"}>
                        <span className="field-control__label">
                            {__("Background Gradient:", "wp-before-after-image-slider")}
                        </span>
                        <div className={"fields-wrapper inline"}>
                            <div className={"field"}>
                                {GradientControl({
                                    props,
                                    attribute: "overlay_gradient_normal",
                                    defaultValue: getAttr("overlay_gradient_normal"),
                                    labelText: __("Default", "wp-before-after-image-slider"),
                                })}
                            </div>
                            <div className={"field"}>
                                {GradientControl({
                                    props,
                                    attribute: "overlay_gradient_hover",
                                    defaultValue: getAttr("overlay_gradient_hover"),
                                    labelText: __("Hover", "wp-before-after-image-slider"),
                                })}
                            </div>
                        </div>
                    </div>
                </ProFeatureControl>
            </PanelRow>
        </PanelBody>
    );
};
